var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackOrderInitial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 243,
    viewBox: "0 0 351 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C61.7792 17.2683 216.72 40.0437 350.248 1",
    stroke: "#1B1836",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.363 62.9443L42.3086 9.14348L89.0513 8.22656L90.1057 62.0296L85.9325 67.173L82.0941 62.1849L77.9197 67.3316L73.5458 62.3545L70.1731 67.4823L66.868 62.4842L63.4952 67.6132L58.3208 62.6527L55.2141 67.7762L51.1085 62.7947L47.4686 67.9292L43.363 62.9443Z",
    fill: "#F5EAD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.363 62.9443L42.3086 9.14348L89.0513 8.22656L90.1057 62.0296L85.9325 67.173L82.0941 62.1849L77.9197 67.3316L73.5458 62.3545L70.1731 67.4823L66.868 62.4842L63.4952 67.6132L58.3208 62.6527L55.2141 67.7762L51.1085 62.7947L47.4686 67.9292L43.363 62.9443Z",
    stroke: "#F5EAD2",
    strokeWidth: 1.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3008 20.2858L82.0592 19.625",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.752 31.543L62.7552 31.248",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.375 31.543L83.3783 31.248",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1289 42.9269L83.7544 42.2461",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.127 52.3587L73.9424 51.873",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2126 10.6992C67.7016 10.6992 68.9079 11.9055 68.9079 13.3934C68.9079 14.8824 67.7016 16.0898 66.2126 16.0898C64.7247 16.0898 63.5195 14.8824 63.5195 13.3934C63.5195 11.9055 64.7247 10.6992 66.2126 10.6992Z",
    fill: "#F5EAD2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.688 78.4758L112.426 10.9922L171.057 17.7166L163.319 85.1991L157.23 90.9334L153.266 84.0472L147.178 89.7793L142.546 82.8187L137.464 88.6661L134.171 81.8574L129.087 87.7048L123.449 80.6279L118.702 86.5141L114.403 79.589L108.986 85.4009L104.688 78.4758Z",
    fill: "#F5EAD2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.688 78.4758L112.426 10.9922L171.057 17.7166L163.319 85.1991L157.23 90.9334L153.266 84.0472L147.178 89.7793L142.546 82.8187L137.464 88.6661L134.171 81.8574L129.087 87.7048L123.449 80.6279L118.702 86.5141L114.403 79.589L108.986 85.4009L104.688 78.4758Z",
    stroke: "#F5EAD2",
    strokeWidth: 1.75
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.354 22.8535L155.429 26.4192",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.375 32.625L137.187 34.2105",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M141.248 35.377L155.061 36.9624",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.998 42.25L153.871 45.9044",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.625 53.25L152.496 56.9044",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M120.625 62.875L143.466 65.4938",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.67 17.1699C143.159 17.1699 144.365 18.3773 144.365 19.8663C144.365 21.3542 143.159 22.5605 141.67 22.5605C140.181 22.5605 138.975 21.3542 138.975 19.8663C138.975 18.3773 140.181 17.1699 141.67 17.1699Z",
    fill: "#F5EAD2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M133.248 221.125V124.852H216.892V221.125L209.246 230.18L202.553 221.125L194.906 230.18L187.258 221.125L181.045 230.18L175.311 221.125L169.095 230.18L160.015 221.125L154.281 230.18L147.109 221.125L140.418 230.18L133.248 221.125Z",
    fill: "#F5EAD2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M133.248 221.125V124.852H216.892V221.125L209.246 230.18L202.553 221.125L194.906 230.18L187.258 221.125L181.045 230.18L175.311 221.125L169.095 230.18L160.015 221.125L154.281 230.18L147.109 221.125L140.418 230.18L133.248 221.125Z",
    stroke: "#F5EAD2",
    strokeWidth: 1.75
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.576 144.988H203.985",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.576 154.799H170.424",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M177.652 155.832H204.501",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M143.578 166.156H205.536",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M143.578 178.547H205.536",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.227 191.375H187.631",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M268.139 54.6377L269.785 7.49219L310.746 8.92257L309.1 56.068L305.2 60.3715L302.078 55.8228L298.178 60.1263L294.588 55.5613L291.39 59.8892L288.737 55.357L285.538 59.6849L281.247 55.0954L278.284 59.4315L274.927 54.8747L271.495 59.1945L268.139 54.6377Z",
    fill: "#F5EAD2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M268.139 54.6377L269.785 7.49219L310.746 8.92257L309.1 56.068L305.2 60.3715L302.078 55.8228L298.178 60.1263L294.588 55.5613L291.39 59.8892L288.737 55.357L285.538 59.6849L281.247 55.0954L278.284 59.4316L274.927 54.8747L271.495 59.1945L268.139 54.6377Z",
    stroke: "#F5EAD2",
    strokeWidth: 1.75
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M274.498 17.5293L304.08 18.5623",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M274.33 22.334L287.477 22.7931",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M291.002 23.4219L304.15 23.881",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M274.137 27.8965L304.478 28.956",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M273.924 33.9648L304.265 35.0244",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M273.533 40.2383L295.278 40.9976",
    stroke: "#1B1836",
    strokeWidth: 1.75
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M291.21 10.7806C292.373 10.8212 293.284 11.7983 293.244 12.9611C293.203 14.1239 292.226 15.0351 291.063 14.9945C289.9 14.9539 288.989 13.9768 289.03 12.814C289.071 11.6511 290.048 10.74 291.21 10.7806Z",
    fill: "#F5EAD2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M198.552 211.03C202.45 211.03 205.608 207.871 205.608 203.974C205.608 200.078 202.45 196.918 198.552 196.918C194.656 196.918 191.496 200.078 191.496 203.974C191.496 207.871 194.656 211.03 198.552 211.03Z",
    fill: "#650D1B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M201.885 202.458C202.143 202.2 202.143 201.781 201.885 201.522C201.628 201.264 201.21 201.264 200.95 201.522L197.449 205.023L196.153 203.728C195.896 203.469 195.477 203.469 195.217 203.728C194.959 203.985 194.959 204.405 195.217 204.663L196.981 206.427C197.241 206.685 197.659 206.685 197.917 206.427L201.885 202.458Z",
    fill: "#FFFFF6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M225.037 165.07L229.179 173.329L295.949 229.647L301.033 223.621L234.263 167.3L225.037 165.07Z",
    fill: "#650D1B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M225.037 165.07L229.179 173.329L295.949 229.647L301.033 223.621L234.263 167.3L225.037 165.07Z",
    stroke: "#650D1B",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M292.426 226.676L297.12 221.112",
    stroke: "#650D1B",
    strokeWidth: 1.75
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M229.932 173.468L234.68 167.84",
    stroke: "#650D1B",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackOrderInitial);
export default __webpack_public_path__ + "static/media/trackOrderInitial.e4080fd26dc5fb6e6b2e9a6e98c676a7.svg";
export { ForwardRef as ReactComponent };